(function () {
(($)=>{
    $(document).ready(function() {
        //HEADER
        $("#menu-burger").click(function() {
            $(this).toggleClass("open");
            $("#header").toggleClass("open");
        });
        //MENU SUB-MENU
        $("#menu-header .menu-item.menu-item-has-children").click(function() {
            if (window.matchMedia(`(max-width: 1280px)`).matches) $(this).toggleClass("open");
        });
        //NEXT SECTION
        $("#page-header #next-section").click(function() {
            const top = $("main section:nth-of-type(2)").offset().top - $("#header").height();
            $("html, body").animate({
                scrollTop: top
            }, 500);
        });
        //MODAL
        $(".cd-modal-trigger").click(function(e) {
            e.preventDefault();
            var content = $(this).find(".modal--content").html();
            openModal(content);
        });
        $(".modal--bg, #modal .close").click(function() {
            closeModal();
        });
        function openModal(content) {
            $("#modal").find(".container").append(content);
            $(".modal--container").addClass("show");
            $("html, body").addClass("overflow-hidden");
        }
        function closeModal() {
            $(".modal--container").removeClass("show");
            $("html, body").removeClass("overflow-hidden");
            setTimeout(function() {
                $("#modal").find(".container").empty();
            }, 300);
        }
        //ACCORDIONS
        $(".accordion .accordion--label").click(function() {
            const accordion = $(this).parent();
            if (accordion.hasClass("active")) accordion.removeClass("active");
            else {
                accordion.parent().find(".accordion.active .accordion--content").stop().slideToggle(300);
                accordion.parent().find(".accordion.active").removeClass("active");
                accordion.addClass("active");
            }
            accordion.find(".accordion--content").stop().slideToggle(300);
        });
        //SECTION ACTIVITIES
        const links = $("#section-activities #link-container a");
        let counter = 1;
        function activitiesFunction() {
            $("#section-activities #link-container a.active").removeClass("active");
            $("#section-activities #activity-container .activity.active").removeClass("active");
            const el = $(`#section-activities #link-container a[data-activity="${counter}"]`);
            const activity = $(`#section-activities #activity-container .activity[data-activity="${counter}"]`);
            el.addClass("active");
            activity.addClass("active");
            if (counter === links.length - 1) counter = 0;
            else counter++;
        }
        let intervalActivities = setInterval(activitiesFunction, 6000);
        links.hover(function() {
            $("#section-activities #link-container a.active").removeClass("active");
            $("#section-activities #activity-container .activity.active").removeClass("active");
            const activity = $(`#section-activities #activity-container .activity[data-activity="${$(this).data("activity")}"]`);
            activity.addClass("active");
            clearInterval(intervalActivities);
        }, function() {
            counter = $(this).data("activity") === links.length - 1 ? 0 : $(this).data("activity") + 1;
            activitiesFunction();
            intervalActivities = setInterval(activitiesFunction, 6000);
        });
    });
})(jQuery);

})();
//# sourceMappingURL=app.js.map
